import { string } from 'prop-types';
import React from 'react';

import SvgIcon from 'ravenjs/lib/SvgIcon';

import { MIGRATED_COLORS } from 'constants/quartz/migrated_colors';

// Glyph source: Material Symbols, Apache-2.0.
const ExitFullscreenFrameIcon = ({ fill, height, viewBox, width, ...rest }) => (
    <SvgIcon height={height} viewBox={viewBox} width={width} {...rest}>
        <path
            d="M240-120v-120H120v-80h200v200h-80Zm400 0v-200h200v80H720v120h-80ZM120-640v-80h120v-120h80v200H120Zm520 0v-200h80v120h120v80H640Z"
            fill={fill}
        />
    </SvgIcon>
);

ExitFullscreenFrameIcon.propTypes = {
    fill: string,
    height: string,
    viewBox: string,
    width: string,
};

ExitFullscreenFrameIcon.defaultProps = {
    fill: MIGRATED_COLORS.black,
    height: '24',
    viewBox: '0 -960 960 960',
    width: '24',
};

export default ExitFullscreenFrameIcon;
